// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"5996":"8d06a44d","6831":"0b02c20c","8503":"f68e9ce8"}[chunkId] || chunkId) + "." + {"5996":"9a6664f05de7bffa","6831":"d2e1a62b280ba1e5","8503":"c4a9251c5814c41e","9683":"93af07e37a463cf4"}[chunkId] + ".js";
};